const config = {
  calendar: 'calendar',
  recent_interview: 'recent interview',
  Month: 'Month',
  Week: 'Week',
  Day: 'Day',
  Agenda: 'Agenda',
  today: 'today',
};

export default config;
